import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Shield } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ACTION_COLORS = {
  create: 'text-emerald-400',
  update: 'text-[#D4AF37]',
  delete: 'text-red-400',
  accept: 'text-emerald-400',
  decline: 'text-red-400',
  pay: 'text-green-400',
  email: 'text-blue-400',
  sms: 'text-blue-400',
  role_change: 'text-[#D4AF37]',
};

const colorFor = (action) => {
  const key = (action || '').split('.').pop().split('_')[0];
  return ACTION_COLORS[key] || 'text-white';
};

const AdminAuditLog = () => {
  const [entries, setEntries] = useState([]);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    axios.get(`${API}/admin/audit-log?limit=500`, { withCredentials: true })
      .then(({ data }) => setEntries(data))
      .catch(console.error);
  }, []);

  const filtered = filter ? entries.filter(e => `${e.action} ${e.actor_name} ${e.target_type} ${JSON.stringify(e.details||{})}`.toLowerCase().includes(filter.toLowerCase())) : entries;

  return (
    <div data-testid="admin-audit-page" className="space-y-6">
      <div>
        <h2 className="font-['Outfit'] text-3xl font-bold text-white mb-2 flex items-center gap-2"><Shield className="w-6 h-6 text-[#D4AF37]" /> Audit Log</h2>
        <p className="text-[#A3A3A3]">Every sensitive action — who, what, when.</p>
      </div>

      <input
        data-testid="audit-filter"
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        placeholder="Filter by actor, action, target..."
        className="w-full max-w-md bg-[#0A0A0A] border border-[#262626] rounded-md px-3 py-2 text-white text-sm placeholder-[#525252] focus:border-[#D4AF37] focus:outline-none"
      />

      <div className="bg-[#141414] border border-[#262626] rounded-md overflow-hidden">
        <table className="w-full">
          <thead className="bg-[#0A0A0A] border-b border-[#262626]">
            <tr>
              <th className="text-left px-4 py-3 text-[#A3A3A3] text-xs uppercase tracking-wider">When</th>
              <th className="text-left px-4 py-3 text-[#A3A3A3] text-xs uppercase tracking-wider">Actor</th>
              <th className="text-left px-4 py-3 text-[#A3A3A3] text-xs uppercase tracking-wider">Action</th>
              <th className="text-left px-4 py-3 text-[#A3A3A3] text-xs uppercase tracking-wider">Target</th>
              <th className="text-left px-4 py-3 text-[#A3A3A3] text-xs uppercase tracking-wider">Details</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr><td colSpan={5} className="text-center px-6 py-8 text-[#A3A3A3]">No audit entries</td></tr>
            ) : filtered.map((e) => (
              <tr key={e.id} className="border-b border-[#262626] last:border-0 hover:bg-[#0A0A0A]">
                <td className="px-4 py-2 text-[#A3A3A3] text-xs whitespace-nowrap">{new Date(e.created_at).toLocaleString()}</td>
                <td className="px-4 py-2 text-white text-sm">{e.actor_name} <span className="text-[#525252] text-xs">({e.actor_role})</span></td>
                <td className={`px-4 py-2 text-sm font-mono ${colorFor(e.action)}`}>{e.action}</td>
                <td className="px-4 py-2 text-[#A3A3A3] text-xs">{e.target_type}{e.target_id ? `:${e.target_id.slice(-6)}` : ''}</td>
                <td className="px-4 py-2 text-[#525252] text-xs max-w-xs truncate">{JSON.stringify(e.details || {})}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminAuditLog;
